module.exports = __webpack_public_path__ + "img/logo.0c182860.png";